<template>
  <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="outDate"
      offset-y
      max-width="290px"
      min-width="auto"
      left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="date"
          label="Měsíc"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          hide-details
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        type="month"
        locale="cs-cz"
        no-title
        scrollable
        @input="$refs.menu.save(date)"
    >
      <v-spacer></v-spacer>
      <v-btn
          text
          color="primary"
          @click="$refs.menu.save('')"
      >
        Zrušit filtr
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "MonthPicker",

  props: {
    modelValue: String,
  },

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  data: () => ({
    date: "",
    outDate: "",
    menu: false,
  }),

  watch: {
    modelValue(val) {
      this.date = val;
    },
    outDate(val) {
      this.$emit('change', val);
    },
  }
}
</script>
